import React from "react";

interface HomeIconProps {
  fill?: string;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const HomeIcon: React.FC<HomeIconProps> = ({
  fill,
  onClick,
  width,
  height,
}) => {
  if (fill === "#DC524C" || fill === "#D3940F") {
    return (
      <svg
        width={width ?? "25"}
        height={height ?? "25"}
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.2194 3.16798C12.539 2.26513 14.2775 2.26513 15.5971 3.16798L22.7957 8.09334C23.8516 8.81584 24.483 10.0129 24.483 11.2924V20.6147C24.483 22.7554 22.7476 24.4908 20.6068 24.4908H6.20966C4.06891 24.4908 2.3335 22.7554 2.3335 20.6147V11.2924C2.3335 10.0129 2.96489 8.81584 4.02086 8.09334L11.2194 3.16798ZM10.6396 19.5072C10.3337 19.5072 10.0858 19.7552 10.0858 20.0609C10.0858 20.3667 10.3337 20.6147 10.6396 20.6147H16.1769C16.4827 20.6147 16.7307 20.3667 16.7307 20.0609C16.7307 19.7552 16.4827 19.5072 16.1769 19.5072H10.6396Z"
          fill={fill}
        />
      </svg>
    );
  } else
    return (
      <svg
        width={width ?? "25"}
        height={height ?? "25"}
        viewBox="0 0 26 25"
        fill={fill === "#DC524C" ? fill : "none"}
        xmlns="http://www.w3.org/2000/svg"
        onClick={onClick}
      >
        <path
          d="M8.83333 17.7083H17.1667M11.9768 2.8792L4.91186 8.37412C4.43961 8.74143 4.20348 8.92509 4.03336 9.15509C3.88267 9.35883 3.77042 9.58835 3.70211 9.83238C3.625 10.1079 3.625 10.407 3.625 11.0053V18.5417C3.625 19.7085 3.625 20.2918 3.85207 20.7375C4.05181 21.1295 4.37052 21.4482 4.76252 21.6479C5.20817 21.875 5.79156 21.875 6.95833 21.875H19.0417C20.2084 21.875 20.7918 21.875 21.2375 21.6479C21.6295 21.4482 21.9482 21.1295 22.1479 20.7375C22.375 20.2918 22.375 19.7085 22.375 18.5417V11.0053C22.375 10.407 22.375 10.1079 22.2979 9.83238C22.2296 9.58835 22.1173 9.35883 21.9666 9.15509C21.7965 8.92509 21.5604 8.74143 21.0881 8.37412L14.0232 2.8792C13.6573 2.59456 13.4743 2.45224 13.2722 2.39753C13.094 2.34926 12.906 2.34926 12.7278 2.39753C12.5257 2.45224 12.3427 2.59456 11.9768 2.8792Z"
          stroke={fill === "#DC524C" ? "#000000" : "#EAECF0"}
          stroke-width={fill === "#DC524C" ? "1" : "2"}
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    );
};

export default HomeIcon;
